export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: '¿Tienes un cupón promocional? Haz click en "Activar" para usarlo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'Su cuenta ha sido cancelada. Suscríbase a un plan para volver a activar su cuenta.',

    //StripeNumberComponent
    change_pay_method: 'Cambiar método de pago',

    //NavigationMyAccountComponent e InformationComponent
    subtitle: 'Gestiona tu perfil, la facturación y la suscripción de tu academia.',
    sections: 'Secciones de Mi cuenta',
    profile_description: 'Datos personales, foto y contraseña',
    billing_details: 'Datos de facturación',
    billing_details_description: 'Datos fiscales y cuenta bancaria',
    my_subscription: 'Mi suscripción',
    my_subscription_description: 'Plan actual y facturas',
    plans_description: 'Cambia de plan o reactívalo',
    my_academies: 'Mis academias',
    my_academies_description: 'Academias de tu cuenta',
    about: 'Acerca de',
    about_description: 'Versión y novedades',
    about_title: 'Información de la aplicación',
    app_name: 'Aplicación',
    manufacturer: 'Fabricante',
    version: 'Versión',
    changelog: 'Novedades',
    current_version: 'Versión actual',
    show_less: 'Ver menos',
    show_full_history: 'Ver el historial completo ({count} más)',
    thanks: 'Gracias por confiar en BrainsPro. Seguimos mejorando la plataforma y aquí puedes consultar las novedades a medida que las publicamos.',
}
